import '../styles/components/badges.css';

export default function StatusBadge({ status }) {
  return <span className={`status-badge ${status}`}>{status}</span>;
}
